module.exports = __webpack_public_path__ + "assets/img/btn-view-aed0555b.png";